'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var IsInView = (_temp = _class = function (_Component) {
    _inherits(IsInView, _Component);

    function IsInView() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, IsInView);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this._timer = null;
        _this._isInView = null;
        _this.onScroll = _this.onScroll.bind(_this);
        _this.check = _this.check.bind(_this);
        return _this;
    }

    IsInView.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.onScroll);
        this.check();
    };

    IsInView.prototype.componentWillUnmount = function componentWillUnmount() {
        this._timer = null;
        window.removeEventListener('scroll', this.onScroll);
    };

    // 为性能，滚动结束再计算，忽略滚动中的事件


    IsInView.prototype.onScroll = function onScroll() {
        if (this._timer) {
            clearTimeout(this._timer);
        }

        this._timer = setTimeout(this.check, this.props.checkInterval);
    };

    IsInView.prototype.check = function check() {
        var _props = this.props,
            checkType = _props.checkType,
            topSpace = _props.topSpace,
            bottomSpace = _props.bottomSpace,
            onChange = _props.onChange;


        this._timer = null;

        var offset = this._el.getBoundingClientRect();
        var isInView = void 0;

        if (checkType === 'top') {
            // 组件是否滚出屏幕上沿
            isInView = offset.top >= topSpace;
        } else if (checkType === 'bottom') {
            // 组件是否滚出屏幕下沿
            isInView = offset.top <= window.innerHeight - bottomSpace;
        } else if (checkType === 'both') {
            // 同时检查上下边距
            isInView = {
                bottom: offset.top <= window.innerHeight - bottomSpace,
                top: offset.top >= topSpace
            };
        }

        if (this._isInView === isInView) {
            return;
        }
        if (checkType === 'both' && this._isInView && this._isInView.top === isInView.top && this._isInView.bottom === isInView.bottom) {
            return;
        }

        onChange(isInView);
        this._isInView = isInView;
    };

    IsInView.prototype.render = function render() {
        var _this2 = this;

        return _react2['default'].createElement('div', { ref: function ref(el) {
                return _this2._el = el;
            } });
    };

    return IsInView;
}(_react.Component), _class.propTypes = {
    bottomSpace: _propTypes2['default'].number,
    topSpace: _propTypes2['default'].number,
    checkType: _propTypes2['default'].string,
    checkInterval: _propTypes2['default'].number,
    onChange: _propTypes2['default'].func
}, _class.defaultProps = {
    bottomSpace: 0,
    topSpace: 0,
    checkType: 'top',
    checkInterval: 10,
    onChange: function onChange() {}
}, _temp);
IsInView.displayName = 'IsInView';
exports['default'] = IsInView;
module.exports = exports['default'];